import { sliceyApi } from '@core/api/httpClient'
import { config } from '@core/config/config'
import type { AppError } from '@core/api/normalizeError'
import type { SendSliceyMessageRequest, SendSliceyMessageResponse } from './sliceyMessageContracts'

const SLICEY_CHAT_PATH = '/api/chat'

export async function postSliceyMessage(
  payload: SendSliceyMessageRequest,
): Promise<SendSliceyMessageResponse> {
  if (!config.sliceyApiUrl) {
    const notConfigured: AppError = {
      message: 'Slicey is not connected yet. Please try again later.',
    }
    throw notConfigured
  }
  const { data } = await sliceyApi.post<SendSliceyMessageResponse>(SLICEY_CHAT_PATH, payload)
  return data
}
